export type CompanionStatus='배터리로 이동'|'손잡이 정렬'|'잡기 준비'|'호흡 맞추는 중'|'장애물 점프'|'낙하물 회수'|'거리 좁히기';
export interface CompanionInput { selfX:number;selfY:number;selfVx:number;grounded:boolean;playerX:number;playerY:number;playerVx:number;playerJumping:boolean;payloadX:number;payloadY:number;held:boolean;selfGripping:boolean;playerGripping:boolean;round:'power'|'oxygen'|'comms' }
export interface CompanionDecision { direction:-1|0|1;jump:boolean;grip:boolean;status:CompanionStatus }
const obstacles=[990,1410,1860,2320];
export function decideCompanion(i:CompanionInput):CompanionDecision{
 const desired=i.payloadX+52+(i.round==='comms'?24:0),dx=desired-i.selfX,separation=i.selfX-i.playerX;
 if(!i.held){
  if(Math.abs(i.selfY-i.payloadY)>150||Math.abs(dx)>170)return{direction:dx>0?1:-1,jump:i.grounded&&obstacles.some(x=>x>i.selfX&&x-i.selfX<75),grip:false,status:'낙하물 회수'};
  if(Math.abs(dx)>34)return{direction:dx>0?1:-1,jump:false,grip:false,status:'손잡이 정렬'};
  return{direction:0,jump:false,grip:true,status:i.playerGripping?'잡기 준비':'배터리로 이동'};
 }
 if(Math.abs(separation)>145)return{direction:separation>0?-1:1,jump:false,grip:true,status:'거리 좁히기'};
 const upcoming=obstacles.some(x=>x>i.selfX&&x-i.selfX<95);
 const jump=i.grounded&&(i.playerJumping||upcoming);
 const velocityGap=i.playerVx-i.selfVx;
 const direction=Math.abs(velocityGap)>35?(velocityGap>0?1:-1):(i.playerVx>35?1:i.playerVx<-35?-1:0);
 return{direction,jump,grip:true,status:jump?'장애물 점프':'호흡 맞추는 중'};
}
